import { useMemo } from 'react';
import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { getDocumentsBySubjectQuery } from '../graphql/queries';

export default function useDocuments({ courseId, subjectId }) {
  /**
   * Get Documents
   */
  const { data, loading, error, refetch } = useQuery(getDocumentsBySubjectQuery, {
    variables: {
      courseId,
      subjectId,
    },
    skip: !courseId || !subjectId,
    fetchPolicy: 'cache-and-network',
  });

  const documents = useMemo(() => data?.documents || [], [data]);

  return {
    documents,
    loading,
    error: getErrorMessage({ error }),
    refetchDocuments: refetch,
  };
}
